import { render, staticRenderFns } from "./WonderTree.vue?vue&type=template&id=1094ab93&scoped=true&"
import script from "./WonderTree.vue?vue&type=script&lang=js&"
export * from "./WonderTree.vue?vue&type=script&lang=js&"
import style0 from "./WonderTree.vue?vue&type=style&index=0&id=1094ab93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1094ab93",
  null
  
)

export default component.exports